function process_card_update(res, $card){
	var cardRedraw = create_overhead_management_card(res);
	const $container = am.$('#om-card-container');
	if(res.updated)
		cardRedraw.insertBefore($card);
	else
		cardRedraw.insertBefore($container.children()[0]);

	check_card_count();
}

function check_card_count(){
	$cardContainer = am.$('#om-card-container')
	setTimeout(function(){
		if($cardContainer.children().length == 1 )
			am.$('#om_none_exists_msg').show();
		else
			am.$('#om_none_exists_msg').hide();
	}, 500)
}

function edit_card(t, id){
	am.$(t).css('pointer-events', 'none');
	remove_options_list();
	const $card = am.$('#om_card_'+id)
	animate_card_face($card, false);
}

function reset_card_values(id){
	// resets vals on card inputs when edit->cancel button is clicked - M. Yandow
	var inputs = am.$('#'+id).children('.am-card-back').find('input, select');
	inputs.each((i, el) =>{
		if(el.value != el.getAttribute('data-prev_state'))
			el.value = el.getAttribute('data-prev_state');
	})
}

function delete_card(t, id){
	var $card = typeof t == 'string' ? am.$('#'+t) : am.$(t);
	$card.css('pointer-events', 'none');

	var params = {
		url: 'update_overhead_management_expense_by_id',
		id: id,
		process: 'delete',
		datatype : 'application/json'
	}

	if($card.attr('data-is_new') == 'true'){
		am.$('#js-save-page').prop('disabled', false);
		var $btn = $card.parent().closest('.js-dataTableDiv').siblings('.am-add-button-cont').children('.am-button-outline-dotted--grey');
		$btn.prop('disabled', false);

		remove_options_list();
		$card = am.$('#om_card_'+id)
		setTimeout(function(){
			annimate_remove_card($card);
			check_card_count();
		}, 250);
	}
	else{
		update_card(params);
	}	
}

function get_card_row($ele){
	var $row = $ele.parent().closest('.row');
	return $row;
}

function get_card($ele){
	var $card = $ele.parent().closest('.am-card')
	return $card;
}

function get_card_save_btn($card){
	var $btn = $card.find('.js-save_btn')
	return $btn;
}

document.on('keydown', '.js-check_value_change', (e) => {
	var number_chk = false;
	if(e.target.getAttribute('data-currency')){
		number_chk = onlyNumberKey(e, true);
	}else {
		number_chk = true;
	}

	if(number_chk){
		document.on('keyup', (e) => {
			check_value_change(e);
		})
	}
})

function check_value_change(e){
	const $this = am.$(e.target);

	var $row = get_card_row($this);
	var $card = get_card($row);
	var $saveBtn = get_card_save_btn($card);
	
	if(e.target.value !== e.target.getAttribute('data-prev_state')){
		e.target.classList.add('js-add_chk_set');
		$saveBtn.prop('disabled', false);
	}else{
		var inputs = $row.find('.js-add_chk_set');
		var chk_arr = [];
		inputs.each((i, inp) => {
			var $inp = am.$(inp);
			if($inp.val() !== $inp.attr('data-prev_state')){
				$saveBtn.prop('disabled', true);
			}else{
				chk_arr.push(true);
			}
		});
	
		if(chk_arr.length == inputs.length)
			$saveBtn.prop('disabled', true);
		else{
			$saveBtn.prop('disabled', false);
		}
	}
}

function animate_card_face($card, front = true){
	if(typeof $card == 'string')
		$card = am.$('#'+$card)

	const $front = $card.children('.am-card-front');
	if($front.hasClass('am-card-front--hide'))
		$front.removeClass('am-card-front--hide')

	const $back = $card.children('.am-card-back');
	if($back.hasClass('am-card-back--show'))
		$back.removeClass('am-card-back--show')

	ensureGSAP().then(function(){
		const tl = gsap.timeline({ duration: .2 })
		if(front){
			tl
				.to($back, { opacity: 0, display: 'none'}, 'start')
				.fromTo($front, {opacity: '0'}, { opacity: 1 }, 'start')
				.to($front, {display: 'flex'})
		}else{
			tl
				.fromTo($front, { opacity: 1 }, { opacity: 0, display: 'none' }, 'start')
				.fromTo($back, {opacity: '0', display: 'none'}, {opacity: 1, display: 'block'})
		}
	});
}

function show_confirm_modal(options){
	const modal = new BSModal( options );
        modal.create_modal();
}